// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export { NotificationBell } from "./ui/NotificationBell.js";
export { NotificationSettings } from "./ui/NotificationSettings.js";
export const NotificationsPage = lazyView(() =>
  import("./ui/NotificationsPage.js").then((m) => m.NotificationsPage),
);
export { NotificationOverlay, NotificationsProvider } from "./ui/center.js";
export { registerNotificationPresenters, type NotificationPresenter } from "./ui/presenters.js";
